<template>
    <div class="container">
        <van-tabs @click="changeActive" v-model="active" class="tabs_header">
            <template #nav-left>
                <van-icon @click="onClickLeft" name="arrow-left" />
            </template>
            <van-tab title="我的抽奖券"> </van-tab>
            <van-tab title="我的抵扣券"> </van-tab>
        </van-tabs>
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <div v-if="active == 0" class="croll">
                <ticket-scroll url="/shop/lottery-roll" :params="{ type }">
                    <panel slot-scope="scope">
                        <div class="tTab">
                            <van-tabs line-height="0" v-model="activeName">
                                <van-tab title="全部" name="a"></van-tab>
                                <van-tab title="待使用" name="b"></van-tab>
                                <van-tab title="已使用" name="c"></van-tab>
                                <van-tab title="已过期" name="d"></van-tab>
                            </van-tabs>
                        </div>
                        <template v-for="(item, i) in scope.data" :key="">
                            <div :class="{
                  crollcard: true,
                  ygq: activeName == 'd' || item.roll_flag == 2,
                  ysy: activeName == 'c' || item.roll_flag == 3,
                }">
                                <div class="left">
                                    <p class="title">{{ item.roll_name }}</p>
                                    <p class="desc">
                                        有效期:{{ timeReplace(item.valid_time) }}
                                        <span class="remain" style="color: #670000">
                                            （还剩{{ expireTime(item.expire_time) }}天到期）
                                        </span>
                                    </p>
                                </div>
                                <div class="right">
                                    <van-button round @click="gotoDraw(item.roll_id)">立即抽奖</van-button>
                                    <p></p>
                                </div>
                                <div class="img-box"></div>
                            </div>
                        </template>
                    </panel>
                </ticket-scroll>
            </div>

            <div v-else-if="active == 1" class="droll">
                <ticket-scroll url="/shop/customer-new-market-deduction-list" :params="{ type2 }">
                    <panel slot-scope="scope">
                        <div class="tTab">
                            <van-tabs line-height="0" v-model="activeName2">
                                <van-tab title="全部" name="a"></van-tab>
                                <van-tab title="待使用" name="b"></van-tab>
                                <van-tab title="已使用" name="c"></van-tab>
                                <van-tab title="已过期" name="d"></van-tab>
                            </van-tabs>
                        </div>
                        <template v-for="(item, i) in scope.data">
                            <div>
                                <div :class="{
                    drollcard: true,
                    ygq: activeName2 == 'd' || item.roll_flag == 2,
                    ysy: activeName2 == 'c' || item.roll_flag == 3,
                  }">
                                    <div class="content">
                                        <div class="left">
                                            <p class="title">{{ item.roll_name }}</p>
                                            <p class="desc">{{ item.expire_time }}过期</p>
                                            <p @click="hrule(i)">
                                                使用规则
                                                <van-icon size="10" class="rule"
                                                    :name="!sindex.includes(i) ? 'arrow-up' : 'arrow-down'" />
                                            </p>
                                        </div>
                                        <div class="right">
                                            <p class="deduct">
                                                ¥{{ Math.floor(item.deduction_price) }}
                                            </p>
                                            <van-button round @click="gotoSy(item.roll_id)">立即使用</van-button>
                                        </div>
                                        <div class="img-box"></div>
                                    </div>
                                    <div v-html="item.rule" v-show="sindex.includes(i)" class="zrule"></div>
                                </div>
                            </div>
                        </template>
                    </panel>
                </ticket-scroll>
            </div>
        </van-pull-refresh>
    </div>
</template>
<script>
    import api from '../Api'
    export default {
        mixins: [api],
        data() {
            return {
                active: Number(this.$route.params.active),
                activeName: "a",
                activeName2: "a",
                sindex: [],
            };
        },
        beforeRouteUpdate(to, from, next) {
            // 切换路由重置首位选中
            if (to.params.active == 0) {
                this.activeName = "a";
            }
            if (to.params.active == 1) {
                this.activeName2 = "a";
            }
            next();
        },
        computed: {
            type() {
                if (this.activeName == "a") {
                    return "all";
                } else if (this.activeName == "b") {
                    return "not_used";
                } else if (this.activeName == "c") {
                    return "is_used";
                } else if (this.activeName == "d") {
                    return "is_expire";
                }
            },
            type2() {
                if (this.activeName2 == "a") {
                    return "all";
                } else if (this.activeName2 == "b") {
                    return "not_used";
                } else if (this.activeName2 == "c") {
                    return "is_used";
                } else if (this.activeName2 == "d") {
                    return "is_expire";
                }
            },
        },
        created() {},
        mounted() {},
        methods: {
            changeActive() {
                this.$router.replace({
                        name: "ticket",
                        params: {
                            active: this.active
                        },
                    },
                    () => {}
                );
            },
            timeReplace(str) {
                return str.replace("-", "~");
            },
            // 使用规则
            hrule(index) {
                if (this.sindex.includes(index)) {
                    this.sindex = this.sindex.filter((item) => item != index);
                } else {
                    this.sindex.push(index);
                }
            },
            gotoSy(roll_id) {
                // this.$router.push({
                //   name: "",
                //   query: {
                //     roll_id,
                //   },
                // });
            },
            gotoDraw(roll_id) {
                // this.$router.push({
                //   name: '',
                //   query: {
                //     rollId: roll_id
                //   }
                // })
            },
            expireTime(time) {
                const extime = (new Date(time) - new Date()) / 1000 / 60 / 60 / 24;
                return Math.ceil(extime);
            },
        },
    };
</script>
<style lang="less" scoped>
    .tTab {
        :deep(.van-tabs__wrap) {
            height: 100%;

            .van-tabs__nav {
                border: none;
                padding-left: 0;
                padding-right: 0;
                height: 1.4rem;
                margin: 0.55rem 0.75rem 0.6rem 6rem;
                border-radius: 1rem;

                .van-tab {
                    border-radius: 1rem;
                    border: none;
                    font-size: 0.6rem;
                    color: #656565;
                }

                .van-tab--active {
                    color: #ffffff;
                    background-color: rgba(103, 0, 0, 0.65);
                }
            }

            .van-tabs__nav--line {
                padding-bottom: 0;
            }
        }
    }

    .croll {
        margin-top: 2.5rem;
        .crollcard {
            padding: 0.9rem 0.6rem;
            margin-bottom: 0.6rem;
            border-radius: 0.7rem;
            background-color: #ffffff;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .title {
                font-size: 0.7rem;
                padding-bottom: 0.6rem;
                color: #000000;
                font-weight: bold;
            }

            .desc {
                font-size: 0.5rem;
                color: #9e9e9e;
            }

            .right {
                .van-button {
                    width: 3.2rem;
                    height: 1.4rem;
                    background: #ecd7d5;
                    border-radius: 1.55rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 0;
                }

                .van-button__text {
                    font-size: 0.6rem;
                    color: #670000;
                }
            }

            .img-box {
                display: none;
            }
        }

        .ygq {

            .right,
            .remain {
                display: none;
            }

            .img-box {
                width: 1.9rem;
                height: 1.9rem;
                display: block;
                background-image: url("../../assets/shopping-icon/expired.png");
                background-repeat: no-repeat;
                background-repeat: no-repeat;
                background-size: contain;
            }
        }

        .ysy {

            .right,
            .remain {
                display: none;
            }

            .img-box {
                width: 1.9rem;
                height: 1.9rem;
                display: block;
                background-image: url("../../assets/shopping-icon/alreadyuse.png");
                background-repeat: no-repeat;
                background-size: contain;
            }
        }
    }

    .droll {
        margin-top: 2.5rem;
        .drollcard {
            padding: 0.9rem 0.6rem;
            margin-bottom: 0.6rem;
            border-radius: 0.7rem;
            background-color: #ffffff;

            .content {
                display: flex;
                justify-content: space-between;
            }

            .title {
                font-size: 0.7rem;
                padding-bottom: 0.6rem;
                color: #000000;
                font-weight: bold;
            }

            .desc {
                font-size: 0.5rem;
                color: #9e9e9e;
                padding-bottom: 0.6rem;
            }

            .right {
                .deduct {
                    text-align: center;
                    font-size: 1.8rem;
                }

                .van-button {
                    width: 3.2rem;
                    height: 1.4rem;
                    background: #ecd7d5;
                    border-radius: 1.55rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 0;
                }

                .van-button__text {
                    font-size: 0.6rem;
                    color: #670000;
                }
            }

            .img-box {
                display: none;
            }
        }

        .ygq {
            .right {
                display: none;
            }

            .img-box {
                width: 1.9rem;
                height: 1.9rem;
                display: block;
                background-image: url("../../assets/shopping-icon/expired.png");
                background-repeat: no-repeat;
                background-repeat: no-repeat;
                background-size: contain;
            }
        }

        .ysy {
            .right {
                display: none;
            }

            .img-box {
                width: 1.9rem;
                height: 1.9rem;
                display: block;
                background-image: url("../../assets/shopping-icon/alreadyuse.png");
                background-repeat: no-repeat;
                background-size: contain;
            }
        }
    }
</style>